export function valuesToSelectOptions(options, prefix, data) {
    return options.map((option) => (Object.assign({ value: `${prefix} : ${option}`, label: option }, data)));
}
export function toGroupSelectOptions(options) {
    return options.map((option) => ({
        label: option.label,
        options: valuesToSelectOptions(option.options, option.label, { tag: `Topic : ${option.label}` }),
    }));
}
